module.exports = __webpack_public_path__ + "img/02_slides.b923ca63.png";